// src/services/apiService.js

import apiClient from "@/api";

//const API_URL = "http://localhost:5000/api";

export default {
  // Existing calls
  fetchUnavailableDates() {
    return apiClient.get('/bookings/unavailable-dates');
  },

  calculatePrice(params) {
    return apiClient.get('/calc-price', { params });
  },

  submitBooking(data) {
    return apiClient.post('/book', data);
  },

  // Admin endpoints
  loginAdmin(credentials) {
    return apiClient.post('/admin/login', credentials);
  },

  // Get all bookings (if needed)
  fetchAllAdminBookings(token) {
    return apiClient.get('/admin/bookings', {
      headers: { Authorization: `Bearer ${token}` }
    });
  },

  // Paid & Unpaid
  fetchPaidBookings(token) {
    return apiClient.get('/admin/bookings/paid', {
      headers: { Authorization: `Bearer ${token}` }
    });
  },

  fetchUnpaidBookings(token) {
    return apiClient.get('/admin/bookings/unpaid', {
      headers: { Authorization: `Bearer ${token}` }
    });
  },

  confirmPayment(bookingId, { status, partial_amount = 0 }, token) {
    return apiClient.post(
      `/admin/bookings/${bookingId}/confirm-payment`,
      { status, partial_amount },
      { headers: { Authorization: `Bearer ${token}` } }
    );
  },
  // NEW: delete booking
  deleteBooking(bookingId, token) {
    return apiClient.delete(`/admin/bookings/${bookingId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
  },

  // NEW: create a booking as admin
  createAdminBooking(data, token) {
    return apiClient.post(
      '/admin/bookings',
      data,
      { headers: { Authorization: `Bearer ${token}` } }
    );
  },

  // NEW: Promo Code Methods

  // Admin: Fetch Promo Codes
  fetchPromocodes(token) {
    return apiClient.get('/admin/promocodes', {
      headers: { Authorization: `Bearer ${token}` }
    });
  },

  // Admin: Create Promo Code
  createPromoCode(promoData, token) {
    return apiClient.post('/admin/promocodes', promoData, {
      headers: { Authorization: `Bearer ${token}` }
    });
  },

  // Admin: Delete Promo Code
  deletePromoCode(promoId, token) {
    return apiClient.delete(`/admin/promocodes/${promoId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
  },

  // Validate Promo Code (Customer)
  validatePromoCode(promoData) {
    return apiClient.post('/validate-promocode', promoData);
  },

  addEditNote(bookingId, note, token) {
    return apiClient.post(`/admin/bookings/${bookingId}/note`, { note }, {
      headers: { Authorization: `Bearer ${token}` }
    });
  },
   // Fetch Add-Ons
   fetchAddOns(token) {
    return apiClient.get('/admin/addons', {
      headers: { Authorization: `Bearer ${token}` }
    });
  },
  fetchPublicAddOns() {
    return apiClient.get('/addons');
  },

  // Create Add-On
  createAddOn(data, token) {
    return apiClient.post('/admin/addons', data, {
      headers: { Authorization: `Bearer ${token}` }
    });
  },

  // Delete Add-On
  deleteAddOn(addonId, token) {
    return apiClient.delete(`/admin/addons/${addonId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
  },
  ChaletInfo(token) {
    return apiClient.get('/listings/1', {
      headers: { Authorization: `Bearer ${token}` }
    });
  },
  ChaletUpdate(data, token) {
    return apiClient.patch('/listings/1', data, {
      headers: { Authorization: `Bearer ${token}` }
    });
  },

};
